import Shortcode from "src/libs/useful/shortcode"
import { ICardFieldProps } from "../cards/CardField"
import TextBlock from "../../useful/TextBlock"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
const CardFieldTitle = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props 
    const style = { 
        ...field.style, 
        ...value.style 
    }
    style.backgroundColor = undefined
    return <div 
        className={`landing-card-field landing-card-field-title h ${value.className || ""}`} 
        style={style} 
        data-card-field-id={i}
        card-field-section-id={section.id}
    >
        <TextBlock 
            editType={ SELECT_TYPE.CARD_FIELD_TITLE }
            section={ section }
            data={ props }
            columns={ 1 }
            text={ value.data }
            className={ ` medallion-padder` } 
        /> 
    </div>
}
export default CardFieldTitle